export default __webpack_public_path__ + "static/media/discount.28f01a6a.svg";